<template>
  <div class="bottom-cube" v-if="isThirdSystem()">

  </div>
</template>

<script>
export default {
  components: {
  },
  props: {

  },
  computed: {
    userInfo () {
      return this.$store.state.user.userInfo
    }
  },
  watch: {},
  created () {},
  mounted () {
  },
  activated () {},
  updated () {},
  methods: {
    isThirdSystem () {
      if (this.userInfo.registerFrom === '10' || this.userInfo.registerFrom === '11') { // 飞书、企业微信手机端页面兼容
        return true
      }
      return false
    }
  }
}
</script>
<style scoped lang='less'>
.bottom-cube{
  height: 60px;
}
</style>
